module.exports = __webpack_public_path__ + "media/assets/images/flags/ro-39e45f9aff1d88a071af09f045950cf2.svg";